import { useCallback, useEffect } from 'react';

import { clearAuthSessionCookies } from '../../utilities/clearAuthSessionCookies';
import { useSafeCookies } from '../useCookies/useSafeCookies';

export const usePendingOpCo = () => {
  const { opco, setOpco } = useSafeCookies();

  const setPendingOpco = useCallback((pendingOpCo: string) => {
    sessionStorage.setItem('pendingOpCo', pendingOpCo);
  }, []);

  useEffect(() => {
    const pending = sessionStorage.getItem('pendingOpCo');
    if (pending && pending !== opco) {
      sessionStorage.removeItem('pendingOpCo');
      clearAuthSessionCookies();
      setOpco(pending);
    }
  }, [opco, setOpco]);

  return {
    setPendingOpco,
  };
};
